// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("_assets/js/" + chunkId + ".bundle.min.js");